var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_90855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54948 16C3.06059 16 2.64192 15.8258 2.29348 15.4773C1.94503 15.1289 1.77111 14.7105 1.7717 14.2222V2.66667H0.882812V0.888889H5.32726V0H10.6606V0.888889H15.105V2.66667H14.2161V14.2222C14.2161 14.7111 14.0419 15.1298 13.6935 15.4782C13.345 15.8267 12.9267 16.0006 12.4384 16H3.54948ZM5.32726 12.4444H7.10503V4.44444H5.32726V12.4444ZM8.88281 12.4444H10.6606V4.44444H8.88281V12.4444Z",
    fill: "#FC8181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_90855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.2be7f63f83c941e91b5e569a0a07133f.svg";
export { ForwardRef as ReactComponent };